<div class="p-3 w-100">
  <div class="d-flex justify-content-start align-items-center">
    <img
      fetchpriority="high"
      width="136"
      height="90"
      src="images/ai-kosh-logo.svg"
      alt="AIKosh"
      title="AIKosh"
    />
    <div class="p-3">
      <h1 class="text-2xl fw-600">Setup Your Identity</h1>
      <p class="text-sm text__gray mb-0">Complete your profile information</p>
    </div>
  </div>
</div>
<div class="p-4 main-container">
  <form [formGroup]="myProfileForm">
    <div class="form-container mb-5">
      <div>
        <h1 class="text-2xl fw-600 mb-2">Contact Details</h1>
        <p class="detail-desc">Verify your Email ID and Mobile Number here.</p>
      </div>
      <div class="card-container p-4 mt-4">
        <div class="row">
          <div class="col-md-6 mb-4">
            <app-text-input
              prefixIcon="images/email-black.svg"
              [suffixIcon]="isEmailVerified ? '/images/success.svg' : ''"
              type="email"
              inputId="contact-detail-email"
              label="Email"
              placeholder="Enter Email"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(myProfileForm.get('email')!)
              "
              [isButton]="isEmailVerifiable"
              [buttonLabel]="'Verify'"
              (onButtonClick)="onVerifyEmail()"
              (onChange)="
                isEmailVerified = '';
                isEmailVerifiable = false;
                myProfileForm.get('email').valid && onInputBlur('email')
              "
            ></app-text-input>
          </div>
          <div class="col-md-6 mb-4">
            <app-text-input
              prefixIcon="images/mobile-black.svg"
              type="tel"
              inputId="contact-detail-phone"
              label="Phone"
              placeholder="Enter your Phone Number"
              [maxLength]="profileFormValidations.mobileNo.maxLength"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(myProfileForm.get('phone')!)
              "
            ></app-text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="form-container mb-5">
      <div>
        <h1 class="text-2xl fw-600 mb-2">Basic Details</h1>
        <p class="detail-desc">Update your photo and personal details here.</p>
      </div>
      <div class="card-container p-4 mt-4">
        <div class="row">
          <div class="col-md-6 mb-4">
            <app-text-input
              type="text"
              [suffixIcon]="isUserNameVerified ? '/images/success.svg' : ''"
              inputId="basic-detail-username"
              label="Username"
              placeholder="Enter Username"
              [maxLength]="profileFormValidations.name.maxLength"
              [isRequired]="true"
              [onKeyPress]="userNameKeypressFn"
              [control]="
                utilityService.$formControl(myProfileForm.get('username')!)
              "
              (onInputBlur)="
                myProfileForm.get('username').valid && onInputBlur('username')
              "
            ></app-text-input>
          </div>
          <div class="col-md-6 mb-4">
            <app-text-input
              type="text"
              inputId="basic-detail-full-name"
              label="Full Name"
              placeholder="Enter Full Name"
              [maxLength]="profileFormValidations.name.maxLength"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(myProfileForm.get('fullName')!)
              "
            ></app-text-input>
          </div>

          <div class="col-12 mb-4">
            <app-input-label
              label="Profile Picture"
              inputId="profile-picture"
              [isRequired]="false"
            ></app-input-label>
            <div
              class="d-flex justify-content-between align-items-start gap-4 mt-3"
            >
              <div
                class="d-flex flex-column align-items-center profile-picture-conatiner"
              >
                <div
                  class="profile-picture overflow-hidden rounded-circle bg-white"
                >
                  <img
                    class="object-fit-contain bg-white"
                    fetchpriority="low"
                    width="64"
                    height="64"
                    [src]="profileImage || 'images/dummy-avatar.svg'"
                    alt="Profile Image"
                  />
                </div>
                @if (profileImage) {
                  <button
                    class="button-no-style delete-img"
                    type="button"
                    (click)="onProfileImageRemove()"
                  >
                    <img
                      fetchpriority="high"
                      width="20"
                      height="20"
                      src="images/delete.svg"
                      alt="Delete"
                    />
                  </button>
                }
              </div>
              <div class="flex-grow-1">
                <app-upload-input
                  [mainInputControl]="
                    utilityService.$formControl(
                      myProfileForm.get('profilePicture')!
                    )
                  "
                  [controlName]="'profilePicture'"
                  [formatsAllowed]="['png', 'jpg', 'jpeg']"
                  (onFileUpload)="onProfileUpload($event)"
                  [fileGuideMesg]="'PNG, JPG, JPEG (max 800x800px, 2MB)'"
                  [maxImgWidth]="800"
                  [maxImgHeight]="800"
                  [resetInput]="resetInput"
                  [maxFileSizeAllowed]="2000"
                >
                </app-upload-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-container mb-5">
      <div>
        <div class="flex-shrink-0 mb-4">
          <app-checkbox-input
            inputId="my-profile-is-agree"
            [control]="
              utilityService.$formControl(myProfileForm.get('isAgreeTnc')!)
            "
            >Click to Agree on our
            <a
              class="text__green cursor-pointer text-decoration-none"
              (click)="onTermsOfServiceClick($event)"
              >Terms of Use</a
            >
            and
            <a
              class="text__green cursor-pointer text-decoration-none"
              (click)="onPrivacyPolicyClick($event)"
              >Privacy Policy</a
            >
            .
          </app-checkbox-input>
        </div>
        <div
          class="d-flex justify-content-end align-items-center gap-3 w-md-auto w-100"
        >
          <button
            class="form-button btn-white flex-md-grow-0 flex-grow-1"
            type="button"
            (click)="redirectToHome()"
          >
            Cancel
          </button>
          <button
            class="form-button btn-secondary flex-md-grow-0 flex-grow-1"
            type="button"
            (click)="onUpdateProfile()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
